import Router from 'next/router';
import axios from 'axios';
var proxyUrl = 'https://cors-anywhere.herokuapp.com/'; // export const baseUrl = "http://wow.kanoon.ir/api";

export var baseUrl = "//wow.kanoon.ir/api"; // export const baseUrl = "https://newapi.rahbod.ir/api";

export var baseUrlMagazine = "https://wowmagazine.ir";
export var baseUrlImage = "http://wow.kanoon.ir";
export default axios.create({
  baseURL: baseUrl,
  headers: {
    'Content-Type': 'application/json'
  }
});
export var apiMagazine = axios.create({
  baseURL: baseUrlMagazine
});
axios.interceptors.response.use(function (response) {
  // Any status code that lie within the range of 2xx cause this function to trigger
  // Do something with response data
  return response;
}, function (error) {
  if (error.response) {
    // The request was made and the server responded with a status code
    // that falls out of the range of 2xx
    if (error.response.status === 401) {
      localStorage.setItem('isLogin', false);
      Router.push('/verifyPhone');
    }
  } // Any status codes that falls outside the range of 2xx cause this function to trigger
  // Do something with response error


  return Promise.reject(error);
});